// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__rVYTD","detailsBorder":"styles_detailsBorder__1GUqH"};